<template>
  <div class="upload-container">
    <el-upload
      action="#"
      list-type="picture-card"
      :auto-upload="false">
    </el-upload>
    <!-- <div class="upload upload-picture-card">
      <i class="el-icon-plus"></i>
      <input type="file" name="file" class="upload__input" :multiple=isMultiple @click="clickMe">
    </div>
    <ul class="upload-list upload-list-picture-card">
      <li class="upload-list__item" v-for="item in fileList" :key="item.url">
        <el-checkbox style="line-height:14px;" @click.native="changeSelected(img,$event)" checked></el-checkbox>
        <img :src="item.url" alt="">
      </li>
    </ul> -->
  </div>
</template>

<script>
export default {
  props: {
    isMultiple: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      fileList: []
    }
  },
  methods: {
    clickMe () {
      console.log('1212')
    },
    changeSelected () {

    }
  }
}
</script>

<style lang="scss" scoped>
.upload-container {
  overflow-x: scroll;
  display: flex;
  flex-wrap: nowrap;
  position: relative;
  height: 175px;

  .upload {
    display: inline-block;
    text-align: center;
    cursor: pointer;
    outline: none;
    position: absolute;
    top: 0;
    left: 0;

    .upload__input {
      display: none;
    }
  }

  .upload-picture-card {
    background-color: #fbfdff;
    border: 1px dashed #c0ccda;
    border-radius: 6px;
    box-sizing: border-box;
    width: 148px;
    height: 148px;
    cursor: pointer;
    line-height: 146px;
    vertical-align: top;
    display: flex;
    margin-bottom: 10px;
    padding: 60px;

    i {
      font-size: 28px;
      color: #8c939d;
      
    }
  }

  .upload-picture-card:hover {
    border: 1px dashed #4d90fe;
  }

  .upload-list {
    margin: 0;
    padding: 0;
    list-style: none;
  }

  .upload-list-picture-card {
    margin: 0;
    vertical-align: top;
    display: flex;

    .upload-list__item {
      overflow: hidden;
      background-color: #fff;
      border: 1px solid #c0ccda;
      border-radius: 6px;
      box-sizing: border-box;
      width: 148px;
      height: 148px;
      margin: 0 8px 8px 0;
      display: inline-block;
    } 
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/components/UploadImage/index.vue